<header class="flex items-center justify-end px-4">
  <section class="flex w-[680px] shrink-0 items-center justify-end gap-5">
    <button class="btn-text" (click)="onCancelButtonClick()">
      {{ 'perio_exam_header_cancel_button_label' | translate }}
    </button>
    <button [disabled]="!isValid()" class="btn-primary-big" (click)="onDoneButtonClick()">
      {{ (isEditing() ? 'perio_exam_header_update_button_label' : 'perio_exam_header_done_button_label') | translate }}
    </button>
    <button class="flex" (click)="onMoreButtonClick($event)">
      <svg-icon class="rotate-90 text-text-primary" key="px-24-more" size="md"></svg-icon>
    </button>
  </section>
</header>
